<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Detalji za operaciju: {{ operation.name }}</h3>
    </div>
    <div class="card-body scrollable scrollable--md">
      <div>
        <div class="mb-10 mt-20 border-bottom fw-bold">Korekcija vremena za zaposlene</div>
        <div>Ostvareno (MIN): {{ operation.timeConsumedEmployeeTotal | number: '1.0-0':'sr-Latn' }}</div>
        <div>Procenjeno (MIN): {{ operation.timeEstimatedEmployee | number: '1.0-0':'sr-Latn' }}</div>
        <div>Korigovano (MIN): {{ operation.timeCorrectionEmployee | number: '1.0-0':'sr-Latn' }}</div>
        <div class="form-group mt-10">
          <input class="form-control" type="number" [(ngModel)]="timeCorrectionEmployee" placeholder="Korekcija vremena">
        </div>
      </div>
      <div>
        <div class="mb-10 mt-20 border-bottom fw-bold">Korekcija vremena za mašine</div>
        <div>Procenjeno (MIN): {{ operation.timeEstimatedMachine | number: '1.0-0':'sr-Latn' }}</div>
        <div>Korigovano (MIN): {{ operation.timeCorrectionMachine ? operation.timeCorrectionMachine + operation.timeEstimatedMachine : operation.timeEstimatedMachine | number: '1.0-0':'sr-Latn' }}</div>
        <div class="form-group mt-10">
          <input class="form-control" type="number" [(ngModel)]="timeCorrectionMachine" placeholder="Korekcija vremena">
        </div>
      </div>
      <div>
        <div class="mb-10 mt-20 border-bottom fw-bold">Korekcija broja komada</div>
        <div>Za planiranje (KOM): {{ operation.quantityCorrection ? operation.quantityToPlan + operation.quantityCorrection : operation.quantityToPlan | number: '1.0-3':'sr-Latn' }}</div>
        <div>Ostvareno (KOM): {{ operation.quantityFinishedTotal | number: '1.0-3':'sr-Latn' }}</div>
        <div>Ukupno (KOM): {{ operation.quantity | number: '1.0-3':'sr-Latn' }}</div>
        <div>Korigovano (KOM): {{ operation.quantityCorrection ? operation.quantityCorrection + operation.quantity : operation.quantity | number: '1.0-3': 'sr-Latn' }}</div>
        <div class="form-group mt-10">
          <input class="form-control" type="number" [(ngModel)]="quantityCorrection" placeholder="Korekcija broja komada">
        </div>
      </div>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question me-3" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-primary btn-question" 
              (click)="correctTimeAndQuantity()" 
              [disabled]="!timeCorrectionEmployee && !timeCorrectionMachine && !quantityCorrection">Sačuvaj</button>
    </div>
  </div>
</div>
